function UserData(usertokenOrObj, name, email, plan, numMonths, autoLoadCID = '', planName = undefined, expDate = undefined) {

    if (usertokenOrObj instanceof Object) {
        let obj = usertokenOrObj

        this.usertoken = obj.usertoken
        this.name = obj.name
        this.email = obj.email
        this.plan = obj.plan
        this.planName = obj.planName || obj.plan
        this.numMonths = Number(obj.numMonths)
        this.autoLoadCID = obj.autoLoadCID
        this.expDate = obj.expDate || 'Unknown'
    }
    else {
        let usertoken = usertokenOrObj
        
        this.usertoken = usertoken
        this.name = name
        this.email = email
        this.plan = plan
        this.planName = planName || plan
        this.numMonths = Number(numMonths)
        this.autoLoadCID = autoLoadCID
        this.expDate = expDate || 'Unknown'
    }    
}

export default UserData